import { apiClient } from '@/lib/api'
import {
  type PosUser,
  type PosUserResponse,
  type PosUserTypeSummary,
  type CreatePosUserRequest,
  type UpdatePosUserRequest,
} from '@/models/domain/pos-user'

interface ListPosUserTypesResponse {
  types?: PosUserTypeSummary[]
}

interface ListPosUsersResponse {
  users?: PosUserResponse[]
}

class PosUserService {
  async listTypes(): Promise<PosUserTypeSummary[]> {
    const response = await apiClient.get<ListPosUserTypesResponse>('/core/v5/pos-users/admin/types')
    return response.types ?? []
  }

  async listAll(system: string): Promise<PosUserResponse[]> {
    const response = await apiClient.get<ListPosUsersResponse>(
      `/core/v5/pos-users/admin/${encodeURIComponent(system)}`
    )
    return response.users ?? []
  }

  async listByLocation(system: string, locationId: string): Promise<PosUserResponse[]> {
    const response = await apiClient.get<ListPosUsersResponse>(
      `/core/v5/pos-users/admin/${encodeURIComponent(system)}/by-location/${locationId}`
    )
    return response.users ?? []
  }

  async listByLevel(system: string, level: number): Promise<PosUserResponse[]> {
    const response = await apiClient.get<ListPosUsersResponse>(
      `/core/v5/pos-users/admin/${encodeURIComponent(system)}/by-level/${level}`
    )
    return response.users ?? []
  }

  async getById(system: string, id: number): Promise<PosUser> {
    return await apiClient.get<PosUser>(
      `/core/v5/pos-users/admin/${encodeURIComponent(system)}/${id}`
    )
  }

  async create(system: string, request: CreatePosUserRequest): Promise<PosUser> {
    return await apiClient.post<PosUser>(
      `/core/v5/pos-users/admin/${encodeURIComponent(system)}`,
      request
    )
  }

  async update(system: string, id: number, request: UpdatePosUserRequest): Promise<PosUser> {
    return await apiClient.put<PosUser>(
      `/core/v5/pos-users/admin/${encodeURIComponent(system)}/${id}`,
      request
    )
  }
}

export const posUserService = new PosUserService()
